import { ActionIcon } from '@mantine/core'
import { User, UserService, useUserRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { ConfirmationModal } from '@ospace/shared'
import { IconPassword } from '@tabler/icons-react'
import React from 'react'
import { useMutation } from 'react-query'

import { useUser } from '../hooks/useUser'

export const SetPasswordButton = ({ user }: { user: User }) => {
  const temporaryPassword = Math.random().toString(36).slice(-8)

  const mutation = useMutation((values: any) => {
    return UserService.setTemporaryPassword(values.email, temporaryPassword)
  })

  const role = useUserRole()
  const { data: currentUser } = useUser()

  const actionHandler = async () => {
    await mutation.mutateAsync({ email: user.email, password: '' })
  }
  if (role !== userTypes.Admin) return null
  return (
    <div className='d-flex'>
      <ConfirmationModal
        alertMessage={
          <div>
            Please copy the temporary password for {user.firstName} {user.lastName}?
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '1rem',
                background: '#e0aeae',
                width: 50,
                justifyContent: 'center',
              }}
            >
              {temporaryPassword}
            </div>
          </div>
        }
        action={actionHandler}
        renderButton={(rp) => (
          <ActionIcon
            {...rp}
            disabled={user.id === currentUser?.id}
            color={user.deletedAt ? 'blue' : 'red'}
            loading={mutation.isLoading && mutation.variables?.identityId === user.identityId}
          >
            <IconPassword />
          </ActionIcon>
        )}
        isLoading={mutation.isLoading && mutation.variables?.identityId === user.identityId}
      />
    </div>
  )
}
